import { Injectable } from '@angular/core';
import { HttpClient, httpResource, HttpResourceRef } from '@angular/common/http';
import { environment } from 'environments/environment';

import { Observable } from 'rxjs';
import { DigitalMachineOptionDto } from '@app/dtos';

@Injectable()
export class MachineService {

    constructor(
        private readonly http: HttpClient,
    ) { }

    getSuggestedTelemetryUnitId(machineVin: string): Observable<string> {
        return this.http.get<string>(`${environment.apiPath}/usermachines/${machineVin}/suggestedTelemetryUnit`);
    }

    declarationOfConformityHeadResource(machineNumber: () => string | undefined): HttpResourceRef<string> {
        // Using HEAD: we only care about success/failure, not the response body.
        // Parsing as text avoids JSON parsing issues when the response body is empty.
        return httpResource.text(() => {
            const n = machineNumber();
            if (!n) {
                return undefined;
            }

            return {
                url: `/${environment.apiPath}/machines/${encodeURIComponent(n)}/declaration-of-conformity`,
                method: 'HEAD',
            };
        });
    }

    availableUpgrades(
        machineNumber: () => string | undefined,
        country: () => string | undefined,
    ): HttpResourceRef<DigitalMachineOptionDto[]> {
        return httpResource<DigitalMachineOptionDto[]>(() => {
            const n = machineNumber();
            const c = country();
            if (!n || !c) {
                return undefined;
            }
            return {
                url: `/${environment.apiPath}/machines/${encodeURIComponent(n)}/digital-options`,
                params: { country: c },
            };
        });
    }
}
